module.exports = __webpack_public_path__ + "img/arrow-down-left-circle.54e1b2e4.svg";